import styled, { css } from 'styled-components';
import { py } from 'styled-components-spacing';
import Button from '../Button/Button';

export const Wrapper = styled.div`
  ${({ theme }) =>
  theme &&
  css`
    ${py(16)};

    display: block;
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: ${theme.zindex.cookie};
    width: 100%;
    background-color: rgba(0, 0, 0, 0.9);
  `}
`;

export const Text = styled.p`
  ${({ theme }) =>
  theme &&
  css`
    color: #fff;
    font-size: ${theme.font.size.pixel('14')};

    a {
      color: #fff;
      font-weight: ${theme.font.weight.bold};
      text-decoration: underline;
    }
  `}
`;

/*
 * Both choices are one click and share the same footprint - refusing must be
 * no harder, and no less visible, than accepting.
 */
export const Actions = styled.div`
  display: flex;
  align-items: stretch;

  > * {
    flex: 1 1 0;
    min-width: 0;
  }

  > * + * {
    margin-left: 8px;
  }
`;

export const AcceptButton = Button;

export const RejectButton = styled(Button)`
  && {
    color: #fff;
    border-color: #fff;
    background-color: transparent;

    &:hover {
      color: #fff;
      border-color: #fff;
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
`;
